<template>
	<div class="plate">
		<div class="titleBg">
			<div class="nav">
				<img src="@/assets/img/plateTitleBg.png" alt="">
				<div class="title text-overflow">{{ title }}</div>
			</div>
			<!-- <div class="more" v-if="isShowMore" @click="moreHandle">{{ more || $t('lang.more') }}</div> -->
		
		</div>

		<div class="content">
			<slot></slot>
		</div>
	</div>
</template>


<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		more: {
			type: String,
			default: ''
		},
        isShowMore:{
            type: Boolean,
            default:true
        }
	},
	methods: {
		moreHandle(){
			this.$emit('moreClick')
		}
	}
}
</script>



<style scoped lang="less">
.plate{
	position: relative;
	width: 100%;
	background: #0D0C0A;
	-o-border-image: linear-gradient(0deg,#4D3A29,#C5B4A0) 10 10;
	border-image: linear-gradient(0deg,#4D3A29,#C5B4A0) 10 10;
	border: 3px solid;
	border-radius: 0.8125rem;
	margin-top: 18px;
	padding: 0 14px 14px;
	.titleBg{
		position: absolute;
		top: -10px;
		left: 10%;
		right: 10%;
		z-index: 5;
		.nav{
			position: relative;
			width: 100%;
			text-align: center;
			img{
				width: 100%;
				height: 50px;
				border-radius: 0px;
				overflow: visible;
				background-color: transparent;
			}
			.title{
				position: absolute;
				left: 17.5%;
				right: 17.5%;
				top: 0;
				max-width: 65%;
				height: 50px;
				line-height: 50px;
				font-size: 16px;
				font-weight: 400;
				color: #f7ebe9;
			}
		}

		.more{
			height: 40px;
			line-height: 40px;
			width: 50px;
			font-size: 12px;
			position: absolute;
			top: 10px;
			right: -40px;
			color: #8e8684;
		}
	}

	.content{
		margin-top: 30px;
	}
}
</style>
